// extracted by mini-css-extract-plugin
module.exports = {"drawer":"project-drawer-module--drawer--BFhmv","drawerContent":"project-drawer-module--drawerContent--28aR5","closeButton":"project-drawer-module--closeButton--1ptH6"};